import React from "react";
import { Button, Container } from "react-bootstrap";
import Navbar from "../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import "./Menu.css";
import Footer2 from "../footer/Footer";
import { Link } from "react-router-dom";
import Navbar1 from "../firstnavbar/FirstNavbar";
import LanguageSelector from "../../Language/LanguageSelector";
function Menu() {
  const { t } = useTranslation();
  return (
    <>
      <Navbar1 />
      <Navbar></Navbar>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Container style={{ marginBottom: "100px" }}>
        {" "}
        <h2 id="menutitle" style={{ textAlign: "center", fontSize: "60px", marginBottom: "40px" }}>
          {" "}
          I nostri Menù
        </h2>{" "}
        <hr />
        <Row style={{ marginTop: "40px", marginBottom: "40px" }}>
          <Col xs={12} md={4} className="button-container">
            <Link to="/carta" className="custom-link" style={{ fontFamily: "cormourant" }}>
              <Button className="custom-button" id="fuorimenu2">
                <span className="button-text">{t("navbar2")}</span>
              </Button>
            </Link>
          </Col>
          <Col xs={12} md={4} className="button-container">
            <LanguageSelector />
          </Col>

          <Col xs={12} md={4} className="button-container">
            <Link to="/fuorimenu" className="custom-link" style={{ fontFamily: "cormourant" }}>
              <Button className="custom-button" id="fuorimenu2">
                <span className="button-text">{t("fuorimenu")}</span>
              </Button>
            </Link>
          </Col>
        </Row>{" "}
        <hr />{" "}
      </Container>
      <div className="footer" id="end"></div>
      <Footer2 />
    </>
  );
}

export default Menu;
